









import Input from '../../common/Input/Input.vue';
import Vue from 'vue';
import { numToKor } from '@/utils/parsers';

export default Vue.extend({
  components: { Input },
  props: {
    value: {
      type: Number,
    },
  },
  data(): {
    count: number;
  } {
    return {
      count: this.value,
    };
  },
  computed: {
    isCountInvalid: function (): boolean {
      if (!this.count) return true;
      return isNaN(this.count) || this.count > 1000000000000000;
    },
    countNaturalLanguage: function (): string {
      if (!this.isCountInvalid) return numToKor(this.count);
      else return '';
    },
  },
  methods: {
    onInput() {
      if (this.isCountInvalid) {
        this.$emit('input', undefined);
      } else {
        this.$emit('input', +this.count);
      }
    },
  },
});
